var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixelfedLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.2273 0 0 19.2273 500.001 500.001)",
    id: 769382
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.3492 -2.314)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.6401 0.5371 -0.7693 0.9168 33.373 2.18)",
    x1: 30.973,
    y1: 27.509,
    x2: 1.109,
    y2: 28.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,92,52)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(235,2,86)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_23)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-26.1508, -35.1859)",
    d: "M 37.345 37.709 c -4.067 -5.563 -11.842 -6.838 -17.368 -2.848 c -5.525 3.99 -6.709 11.735 -2.643 17.297 l 0.308 0.421 c -6.63 -8.673 -6.957 -20.838 -0.347 -29.753 l 0.118 -0.157 c 4.095 -5.442 11.877 -6.487 17.381 -2.334 c 5.504 4.153 6.646 11.932 2.55 17.374 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.0392 10.0182)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.9332 0.783 -0.5277 0.6289 33.373 2.18)",
    x1: 18.604,
    y1: 60.089,
    x2: 29.552,
    y2: 34.263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(166,63,219)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,37,126)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_24)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-30.4608, -47.5182)",
    d: "M 37.345 37.709 c -6.473 2.19 -9.878 9.222 -7.606 15.708 c 2.273 6.487 9.363 9.97 15.836 7.78 l 0.43 -0.145 c -8.05 2.88 -17.429 1.495 -24.514 -4.45 a 25.35 25.35 0 0 1 -3.849 -4.023 l -0.308 -0.42 c -4.066 -5.563 -2.882 -13.308 2.643 -17.298 c 5.526 -3.99 13.301 -2.715 17.368 2.848 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.1118 12.2776)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.6731 0.5648 -0.7316 0.8719 33.373 2.18)",
    x1: 31.906,
    y1: 22.861,
    x2: 56.143,
    y2: 28.198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,255,240)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,135,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_25)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-45.6118, -49.7776)",
    d: "M 37.345 37.709 c 0.041 6.845 5.636 12.429 12.497 12.47 c 6.86 0.042 12.388 -5.474 12.346 -12.32 l -0.001 -0.156 c 0.073 5.679 -1.798 11.389 -5.714 16.056 a 24.32 24.32 0 0 1 -10.469 7.293 l -0.429 0.146 c -6.473 2.189 -13.563 -1.294 -15.836 -7.78 c -2.272 -6.487 1.133 -13.52 7.606 -15.71 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.2661 -5.4089)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8028 0.6736 -0.6133 0.731 33.373 2.18)",
    x1: 40.014,
    y1: 3.05,
    x2: 21.611,
    y2: 22.693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(23,201,52)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(3,255,110)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_26)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-49.7661, -32.0911)",
    d: "M 37.345 37.709 c 6.537 2.155 13.523 -1.366 15.603 -7.863 c 2.08 -6.498 -1.532 -13.512 -8.07 -15.667 l -0.535 -0.177 a 25.153 25.153 0 0 1 8.855 4.813 a 25.042 25.042 0 0 1 8.989 18.888 v 0.157 c 0.043 6.845 -5.485 12.361 -12.345 12.32 c -6.86 -0.042 -12.456 -5.626 -12.497 -12.471 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.0844 -11.8699)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8728 0.7323 -0.5642 0.6724 33.373 2.18)",
    x1: 15.185,
    y1: 33.22,
    x2: 9.592,
    y2: 1.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,176,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,119,37)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_27)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-35.4156, -25.6302)",
    d: "M 37.345 37.709 c 4.095 -5.442 2.953 -13.22 -2.55 -17.374 c -5.505 -4.153 -13.287 -3.108 -17.382 2.334 l -0.118 0.157 c 0.294 -0.396 0.6 -0.785 0.921 -1.167 c 6.529 -7.78 16.896 -10.467 26.127 -7.657 l 0.535 0.177 c 6.538 2.155 10.15 9.169 8.07 15.667 c -2.08 6.497 -9.066 10.018 -15.603 7.863 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.3746 0.9272 -0.9272 -0.3746 11.252 3.9196)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8544 0 0 1.1704 0 0)",
    x1: 16.691,
    y1: 19.196,
    x2: 57.873,
    y2: 21.721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(158,232,93)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(14,208,97)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_28)",
      fillRule: "nonzero",
      opacity: 0.5443
    },
    transform: " translate(-37.0552, -20.1788)",
    d: "m 28.38 9.27 l 0.186 -0.074 c 6.394 -2.552 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.502 -6.899 16.053 a 12.225 12.225 0 0 0 -0.508 -2.904 c 3.43 -1.857 5.756 -5.456 5.756 -9.592 c 0 -6.037 -4.955 -10.93 -11.067 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.3746 0.9272 -0.9272 -0.3746 11.252 3.9196)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 0.5,
      fillRule: "nonzero",
      opacity: 0.5443
    },
    transform: " translate(-37.0552, -20.1788)",
    d: "m 28.38 9.27 l 0.186 -0.074 c 6.394 -2.552 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.502 -6.899 16.053 a 12.225 12.225 0 0 0 -0.508 -2.904 c 3.43 -1.857 5.756 -5.456 5.756 -9.592 c 0 -6.037 -4.955 -10.93 -11.067 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.0844 -11.8699)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8728 0.7323 -0.5642 0.6724 33.373 2.18)",
    x1: 15.185,
    y1: 33.22,
    x2: 9.592,
    y2: 1.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,176,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,119,37)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_29)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-35.4156, -25.6302)",
    d: "M 37.345 37.709 c 4.095 -5.442 2.953 -13.22 -2.55 -17.374 c -5.505 -4.153 -13.287 -3.108 -17.382 2.334 l -0.118 0.157 c 0.294 -0.396 0.6 -0.785 0.921 -1.167 c 6.529 -7.78 16.896 -10.467 26.127 -7.657 l 0.535 0.177 c 6.538 2.155 10.15 9.169 8.07 15.667 c -2.08 6.497 -9.066 10.018 -15.603 7.863 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.9435 -9.7679)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.7324 -0.4401 0.6028 1.0032 7.061 16.678)",
    x1: 26.799,
    y1: 19.64,
    x2: 6.491,
    y2: 20.515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,92,52)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(235,2,86)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_30)",
      fillRule: "nonzero",
      opacity: 0.1801
    },
    transform: " translate(-28.5565, -27.732)",
    d: "m 17.324 22.991 l 0.122 -0.16 c 4.166 -5.48 11.975 -6.613 17.441 -2.53 c 5.467 4.082 6.52 11.834 2.355 17.314 a 12.225 12.225 0 0 0 -1.932 -2.228 c 1.984 -3.358 2.124 -7.641 -0.006 -11.186 c -3.11 -5.175 -9.877 -6.818 -15.116 -3.67 a 11.17 11.17 0 0 0 -2.864 2.46 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8572 -0.515 0.515 0.8572 -6.9537 -9.4709)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8544 0 0 1.1704 0 0)",
    x1: 26.799,
    y1: 19.64,
    x2: 6.491,
    y2: 20.515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,92,52)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(235,2,86)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_31)",
      fillRule: "nonzero",
      opacity: 0.1801
    },
    transform: " translate(-14.2222, -21.6058)",
    d: "m 5.546 10.697 l 0.187 -0.074 c 6.393 -2.552 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.502 -6.9 16.053 a 12.225 12.225 0 0 0 -0.508 -2.904 c 3.43 -1.857 5.756 -5.456 5.756 -9.592 c 0 -6.037 -4.955 -10.93 -11.066 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8572 -0.515 0.515 0.8572 -6.9537 -9.4709)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 0.77,
      fillRule: "nonzero",
      opacity: 0.1801
    },
    transform: " translate(-14.2222, -21.6058)",
    d: "m 5.546 10.697 l 0.187 -0.074 c 6.393 -2.552 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.502 -6.9 16.053 a 12.225 12.225 0 0 0 -0.508 -2.904 c 3.43 -1.857 5.756 -5.456 5.756 -9.592 c 0 -6.037 -4.955 -10.93 -11.066 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.225 -0.9744 0.9744 -0.225 -11.4765 3.7866)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8544 0 0 1.1704 0 0)",
    x1: 32.778,
    y1: 31.292,
    x2: -5.737,
    y2: 34.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(166,63,219)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,37,126)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_32)",
      fillRule: "nonzero",
      opacity: 0.5842
    },
    transform: " translate(-19.3302, -34.6735)",
    d: "m 10.654 23.765 l 0.187 -0.075 c 6.393 -2.551 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.503 -6.9 16.054 a 12.225 12.225 0 0 0 -0.507 -2.904 c 3.43 -1.857 5.755 -5.456 5.755 -9.592 c 0 -6.037 -4.954 -10.93 -11.066 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.225 -0.9744 0.9744 -0.225 -11.4765 3.7866)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 0.5,
      fillRule: "nonzero",
      opacity: 0.5842
    },
    transform: " translate(-19.3302, -34.6735)",
    d: "m 10.654 23.765 l 0.187 -0.075 c 6.393 -2.551 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.503 -6.9 16.054 a 12.225 12.225 0 0 0 -0.507 -2.904 c 3.43 -1.857 5.755 -5.456 5.755 -9.592 c 0 -6.037 -4.954 -10.93 -11.066 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9986 -0.0523 0.0523 -0.9986 0.149 12.1837)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.8544 0 0 1.1704 0 0)",
    x1: 38.66,
    y1: 42.314,
    x2: 29.418,
    y2: 17.769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(33,239,227)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(37,152,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_33)",
      fillRule: "nonzero",
      opacity: 0.5622
    },
    transform: " translate(-33.8112, -33.6408)",
    d: "m 25.135 22.732 l 0.187 -0.074 c 6.393 -2.552 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.502 -6.899 16.053 a 12.225 12.225 0 0 0 -0.508 -2.904 c 3.43 -1.857 5.755 -5.456 5.755 -9.592 c 0 -6.037 -4.954 -10.93 -11.066 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9986 -0.0523 0.0523 -0.9986 0.149 12.1837)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.5622
    },
    transform: " translate(-33.8112, -33.6408)",
    d: "m 25.135 22.732 l 0.187 -0.074 c 6.393 -2.552 13.67 0.5 16.253 6.814 c 2.583 6.315 -0.506 13.502 -6.899 16.053 a 12.225 12.225 0 0 0 -0.508 -2.904 c 3.43 -1.857 5.755 -5.456 5.755 -9.592 c 0 -6.037 -4.954 -10.93 -11.066 -10.93 a 11.17 11.17 0 0 0 -3.722 0.633 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.9406 -11.2708)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 0.5,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-45.4406, -26.2292)",
    d: "m 44.687 14.116 l 0.191 0.063 c 6.538 2.155 10.15 9.169 8.07 15.667 c -2.08 6.497 -9.066 10.018 -15.603 7.863 a 12.225 12.225 0 0 0 1.477 -2.552 c 3.821 0.783 7.916 -0.48 10.575 -3.648 c 3.88 -4.624 3.23 -11.558 -1.452 -15.486 a 11.17 11.17 0 0 0 -3.258 -1.907 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.791 1.0995)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-27.006, -51.0995)",
    d: "M 24.1 55.523 h 4.546 c 4.281 0 7.752 -3.364 7.752 -7.513 c 0 -4.15 -3.47 -7.513 -7.752 -7.513 h -6.56 c -2.47 0 -4.472 1.94 -4.472 4.335 v 16.87 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.791 1.0995)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-38.291, -38.5995)",
    d: "M 35.386 43.023 h 4.545 c 4.281 0 7.752 -3.364 7.752 -7.513 c 0 -4.15 -3.47 -7.513 -7.752 -7.513 h -6.56 c -2.47 0 -4.472 1.94 -4.472 4.335 v 16.87 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelfedLogo);
export default __webpack_public_path__ + "static/media/pixelfed-logo.662d0642f6009889e244714706417202.svg";
export { ForwardRef as ReactComponent };